import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { afterSignInPath } from "@/lib/auth-return";

// Sign-in and sign-up pages that have nothing to offer someone already signed in.
const SIGNED_OUT_ONLY = ["/cont/login", "/cont/inregistrare"];

// Shell for /cont/login, /cont/inregistrare and /cont/parola-uitata. The pages render their own
// full-screen chrome. A signed-in user who lands on the sign-in or sign-up page — Back into an old
// login entry, a bookmark, a second tab — is moved on to where the page would send them after
// signing in, instead of being shown a form they don't need.
export function AuthShell() {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const [params] = useSearchParams();
  if (!loading && user && SIGNED_OUT_ONLY.includes(pathname)) {
    return <Navigate to={afterSignInPath(params.get("next"))} replace />;
  }
  return <Outlet />;
}
